import React, { useState } from 'react';
import { t } from 'ttag';
import { Field, FormProps, withTypes } from 'react-final-form';

import { FeedFilterTitle } from '@components/FeedFilterTitle';
import { Checkbox } from '@ui/Checkbox';
import { Link } from '@ui/Link';
import { Modal } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { CitySelectContainer } from '@containers/CitySelect';
import { FormError } from '@ui/FormError';

import s from './FeedCityFilter.sss';

export type FeedCityFilterProps = FormProps<FormValues> & {
  value: number | undefined;
  onChange: (cityId: number | undefined) => void;
  options: { value: number; label: string }[];
  className?: string
};

export type FormValues = {
  city: { value: number; label: string };
};

export const FeedCityFilter: React.FC<FeedCityFilterProps> = ({
  value,
  onChange,
  options,
  className,
  // Form props
  onSubmit: onSubmitProp,
  ...props
}) => {
  const [isHide, setHide] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const { Form } = withTypes<FormValues>();

  const onSubmit: FormProps<FormValues>['onSubmit'] = async (...args) => {
    const errors = await onSubmitProp(...args);
    if (!errors) {
      setModalOpen(false);
      onChange(undefined);
    }

    return errors;
  };

  return (
    <div className={className}>
      <FeedFilterTitle
        title={t`Місто`}
        hide={isHide}
        onClick={() => setHide(!isHide)}
      />
      {!isHide && (
        <>
          <div>
            {
              options.map((option) => (
                <Checkbox
                  key={option.value}
                  inputClassName={s.checkbox}
                  checked={option.value === value}
                  onCheck={() => onChange(option.value === value ? undefined : option.value)}
                >
                  {option.label}
                </Checkbox>
              ))
            }
          </div>

          <Link
            className={s.changeButton}
            href="#"
            role="button"
            onClick={(e) => {
              e.preventDefault();
              setModalOpen(true);
            }}
          >
            {t`Змінити`}
          </Link>
        </>
      )}

      <Modal
        className={s.modal}
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
        withClose={true}
      >
        <Form
          {...props}
          onSubmit={onSubmit}
          render={({ handleSubmit, pristine, submitting, submitError }) => (
            <form onSubmit={handleSubmit}>
              <Title type="h2">
                {t`Вкажіть, будь ласка, ваше місто`}
              </Title>

              <p className={s.description}>
                {t`Ми зможемо знайти цікаві пропозиції від продавців з вашого міста`}
              </p>

              <Field<FormValues['city']>
                name="city"
                render={
                  ({ input, meta }) => (
                    <CitySelectContainer
                      className={s.citySelect}
                      {...input}
                      label={t`Місто`}
                      error={(meta.touched && meta.error) || meta.submitError}
                    />
                  )
                }
              />

              <Button
                type={pristine ? 'button' : 'submit'}
                className={s.submit}
                disabled={submitting}
              >
                {t`Продовжити`}
              </Button>
              {submitError && <FormError>{submitError}</FormError>}
            </form>
          )}
        />
      </Modal>
    </div>
  );
};
